



























import { Vue, Component } from 'vue-property-decorator'

@Component({
  components: {},
})
export default class Result extends Vue {
  codeTxt: string = '5S后返回创作中心'
  status: string = 'wait'
  beforeMount() {
    this.loopTime()
  }

  loopTime(): void {
    let timeNum = 5
    const timeId = setInterval(() => {
      timeNum--
      if (timeNum < 1) {
        this.$router.push({ path: '/' })
        clearInterval(timeId)
        return
      }
      this.codeTxt = timeNum + 'S后返回创作中心'
    }, 1000)
  }
}
